<template>
    <modal :portal="true" v-model="showModal" size="md">

        <template #title>
            <h3 class="panel-title">
                <i class="fa-regular fa-sort m-r-10"></i>
                <slot name="title"></slot>
            </h3>
        </template>

        <div class="p-0">

            <ep-banner v-if="$slots['info-box']">
                <slot name="info-box"></slot>
            </ep-banner>

            <div class="panel panel-default m-b-10 cursor-grabbing">

                <div class="panel-heading" v-if="$slots['list-heading']">
                    <slot name="list-heading"></slot>
                </div>

                <div class="panel-body grabbable p-0" ref="sortable">
                    <div v-for="resource in resources" :data-id="resource.id">
                        <div class="flex-align organize-align"
                              style="border: 1px solid #dcdcdc; border-top: 0; background-color: white; padding: 5px 0 5px 10px;">
                            <span class="title">
                                <i class="fa-regular fa-grip-dots-vertical m-r-10"></i>
                                {{ getResourceTitle(resource) }}
                            </span>
                        </div>
                    </div>
                </div>

            </div>

        </div>

        <template #footer>
            <div class="row">
                <div class="col-xs-12">
                    <button type="submit" class="btn btn-custom pull-right" @click="ready">
                        {{ trans('global.save') }}
                    </button>
                </div>
            </div>
        </template>

    </modal>
</template>

<script>
/**
 *  A modal component which lets the user organize a list of resources.
 *  The list is organized using the 'id' property for each resource,
 *  and when ready, emits the new id order in an array of numbers.
 *
 *  E.g. [3, 4, 2, 1]
 */

import Sortable from 'sortablejs';
import Modal from 'Components/global/Modal.vue';

export default {
    components: { Modal },
    props: {
        value: {
            type: Boolean,
            required: true,
        },
        resources: {
            type: Array,
            required: true,
        },
    },
    data: function() {
        return {
            sorting: [],
            sortable: null,
            resourcesArray: this.resources,
            showModal: this.value,
        };
    },

    methods: {
        toggle(show) {
            this.showModal = show;

            if (!show) {
                if (this.sortable) this.sortable.destroy();
                return;
            }

            this.sortable = Sortable.create(this.$refs.sortable, {
                store: {
                    //Get the order of elements. Called once during initialization.
                    get: () => {
                        return this.resourcesArray.map(({ id }) => id);
                    },

                    //Save the order of elements. Called onEnd (when the item is dropped).
                    set: (sortable) => {
                        this.sorting = sortable.toArray();
                    },
                },
            });
        },

        ready() {
            this.$emit('reorganized', this.sorting.map((id) => parseInt(id)));
        },

        getResourceTitle(resource) {
            return resource.title ?? resource.id;
        },
    },

    watch: {
        // Listen for model from parent
        value(newValue) {
            this.toggle(newValue);
        },
        // Listen for model update by child (modal) component
        showModal(newValue) {
            // Propagate change to parent component.
            this.$emit('input', newValue);
        },
        resources(newValue) {
            this.resourcesArray = newValue;
        },
    },
};
</script>
